/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import { sortObjectKeysUsingValue } from './functions';

export const worldCountries = sortObjectKeysUsingValue( {
	AF: _x( 'Afghanistan', 'text', 'nelio-ab-testing' ),
	AX: _x( 'Åland Islands', 'text', 'nelio-ab-testing' ),
	AL: _x( 'Albania', 'text', 'nelio-ab-testing' ),
	DZ: _x( 'Algeria', 'text', 'nelio-ab-testing' ),
	AS: _x( 'American Samoa', 'text', 'nelio-ab-testing' ),
	AD: _x( 'Andorra', 'text', 'nelio-ab-testing' ),
	AO: _x( 'Angola', 'text', 'nelio-ab-testing' ),
	AI: _x( 'Anguilla', 'text', 'nelio-ab-testing' ),
	AQ: _x( 'Antarctica', 'text', 'nelio-ab-testing' ),
	AG: _x( 'Antigua and Barbuda', 'text', 'nelio-ab-testing' ),
	AR: _x( 'Argentina', 'text', 'nelio-ab-testing' ),
	AM: _x( 'Armenia', 'text', 'nelio-ab-testing' ),
	AW: _x( 'Aruba', 'text', 'nelio-ab-testing' ),
	AU: _x( 'Australia', 'text', 'nelio-ab-testing' ),
	AT: _x( 'Austria', 'text', 'nelio-ab-testing' ),
	AZ: _x( 'Azerbaijan', 'text', 'nelio-ab-testing' ),
	BS: _x( 'Bahamas', 'text', 'nelio-ab-testing' ),
	BH: _x( 'Bahrain', 'text', 'nelio-ab-testing' ),
	BD: _x( 'Bangladesh', 'text', 'nelio-ab-testing' ),
	BB: _x( 'Barbados', 'text', 'nelio-ab-testing' ),
	BY: _x( 'Belarus', 'text', 'nelio-ab-testing' ),
	BE: _x( 'Belgium', 'text', 'nelio-ab-testing' ),
	BZ: _x( 'Belize', 'text', 'nelio-ab-testing' ),
	BJ: _x( 'Benin', 'text', 'nelio-ab-testing' ),
	BM: _x( 'Bermuda', 'text', 'nelio-ab-testing' ),
	BT: _x( 'Bhutan', 'text', 'nelio-ab-testing' ),
	BO: _x( 'Bolivia', 'text', 'nelio-ab-testing' ),
	BQ: _x( 'Bonaire, Sint Eustatius and Saba', 'text', 'nelio-ab-testing' ),
	BA: _x( 'Bosnia and Herzegovina', 'text', 'nelio-ab-testing' ),
	BW: _x( 'Botswana', 'text', 'nelio-ab-testing' ),
	BV: _x( 'Bouvet Island', 'text', 'nelio-ab-testing' ),
	BR: _x( 'Brazil', 'text', 'nelio-ab-testing' ),
	IO: _x( 'British Indian Ocean Territory', 'text', 'nelio-ab-testing' ),
	BN: _x( 'Brunei Darussalam', 'text', 'nelio-ab-testing' ),
	BG: _x( 'Bulgaria', 'text', 'nelio-ab-testing' ),
	BF: _x( 'Burkina Faso', 'text', 'nelio-ab-testing' ),
	BI: _x( 'Burundi', 'text', 'nelio-ab-testing' ),
	KH: _x( 'Cambodia', 'text', 'nelio-ab-testing' ),
	CM: _x( 'Cameroon', 'text', 'nelio-ab-testing' ),
	CA: _x( 'Canada', 'text', 'nelio-ab-testing' ),
	CV: _x( 'Cape Verde', 'text', 'nelio-ab-testing' ),
	KY: _x( 'Cayman Islands', 'text', 'nelio-ab-testing' ),
	CF: _x( 'Central African Republic', 'text', 'nelio-ab-testing' ),
	TD: _x( 'Chad', 'text', 'nelio-ab-testing' ),
	CL: _x( 'Chile', 'text', 'nelio-ab-testing' ),
	CN: _x( 'China', 'text', 'nelio-ab-testing' ),
	CX: _x( 'Christmas Island', 'text', 'nelio-ab-testing' ),
	CC: _x( 'Cocos (Keeling) Islands', 'text', 'nelio-ab-testing' ),
	CO: _x( 'Colombia', 'text', 'nelio-ab-testing' ),
	KM: _x( 'Comoros', 'text', 'nelio-ab-testing' ),
	CG: _x( 'Congo', 'text', 'nelio-ab-testing' ),
	CD: _x(
		'Congo, the Democratic Republic of the',
		'text',
		'nelio-ab-testing'
	),
	CK: _x( 'Cook Islands', 'text', 'nelio-ab-testing' ),
	CR: _x( 'Costa Rica', 'text', 'nelio-ab-testing' ),
	CI: _x( 'Côte d’Ivoire', 'text', 'nelio-ab-testing' ),
	HR: _x( 'Croatia', 'text', 'nelio-ab-testing' ),
	CU: _x( 'Cuba', 'text', 'nelio-ab-testing' ),
	CW: _x( 'Curaçao', 'text', 'nelio-ab-testing' ),
	CY: _x( 'Cyprus', 'text', 'nelio-ab-testing' ),
	CZ: _x( 'Czech Republic', 'text', 'nelio-ab-testing' ),
	DK: _x( 'Denmark', 'text', 'nelio-ab-testing' ),
	DJ: _x( 'Djibouti', 'text', 'nelio-ab-testing' ),
	DM: _x( 'Dominica', 'text', 'nelio-ab-testing' ),
	DO: _x( 'Dominican Republic', 'text', 'nelio-ab-testing' ),
	EC: _x( 'Ecuador', 'text', 'nelio-ab-testing' ),
	EG: _x( 'Egypt', 'text', 'nelio-ab-testing' ),
	SV: _x( 'El Salvador', 'text', 'nelio-ab-testing' ),
	GQ: _x( 'Equatorial Guinea', 'text', 'nelio-ab-testing' ),
	ER: _x( 'Eritrea', 'text', 'nelio-ab-testing' ),
	EE: _x( 'Estonia', 'text', 'nelio-ab-testing' ),
	SZ: _x( 'Eswatini', 'text', 'nelio-ab-testing' ),
	ET: _x( 'Ethiopia', 'text', 'nelio-ab-testing' ),
	FK: _x( 'Falkland Islands (Malvinas)', 'text', 'nelio-ab-testing' ),
	FO: _x( 'Faroe Islands', 'text', 'nelio-ab-testing' ),
	FJ: _x( 'Fiji', 'text', 'nelio-ab-testing' ),
	FI: _x( 'Finland', 'text', 'nelio-ab-testing' ),
	FR: _x( 'France', 'text', 'nelio-ab-testing' ),
	GF: _x( 'French Guiana', 'text', 'nelio-ab-testing' ),
	PF: _x( 'French Polynesia', 'text', 'nelio-ab-testing' ),
	TF: _x( 'French Southern Territories', 'text', 'nelio-ab-testing' ),
	GA: _x( 'Gabon', 'text', 'nelio-ab-testing' ),
	GM: _x( 'Gambia', 'text', 'nelio-ab-testing' ),
	GE: _x( 'Georgia', 'text', 'nelio-ab-testing' ),
	DE: _x( 'Germany', 'text', 'nelio-ab-testing' ),
	GH: _x( 'Ghana', 'text', 'nelio-ab-testing' ),
	GI: _x( 'Gibraltar', 'text', 'nelio-ab-testing' ),
	GR: _x( 'Greece', 'text', 'nelio-ab-testing' ),
	GL: _x( 'Greenland', 'text', 'nelio-ab-testing' ),
	GD: _x( 'Grenada', 'text', 'nelio-ab-testing' ),
	GP: _x( 'Guadeloupe', 'text', 'nelio-ab-testing' ),
	GU: _x( 'Guam', 'text', 'nelio-ab-testing' ),
	GT: _x( 'Guatemala', 'text', 'nelio-ab-testing' ),
	GG: _x( 'Guernsey', 'text', 'nelio-ab-testing' ),
	GN: _x( 'Guinea', 'text', 'nelio-ab-testing' ),
	GW: _x( 'Guinea-Bissau', 'text', 'nelio-ab-testing' ),
	GY: _x( 'Guyana', 'text', 'nelio-ab-testing' ),
	HT: _x( 'Haiti', 'text', 'nelio-ab-testing' ),
	HM: _x( 'Heard Island and Mcdonald Islands', 'text', 'nelio-ab-testing' ),
	VA: _x( 'Holy See (Vatican City State)', 'text', 'nelio-ab-testing' ),
	HN: _x( 'Honduras', 'text', 'nelio-ab-testing' ),
	HK: _x( 'Hong Kong', 'text', 'nelio-ab-testing' ),
	HU: _x( 'Hungary', 'text', 'nelio-ab-testing' ),
	IS: _x( 'Iceland', 'text', 'nelio-ab-testing' ),
	IN: _x( 'India', 'text', 'nelio-ab-testing' ),
	ID: _x( 'Indonesia', 'text', 'nelio-ab-testing' ),
	IR: _x( 'Iran, Islamic Republic of', 'text', 'nelio-ab-testing' ),
	IQ: _x( 'Iraq', 'text', 'nelio-ab-testing' ),
	IE: _x( 'Ireland', 'text', 'nelio-ab-testing' ),
	IM: _x( 'Isle of Man', 'text', 'nelio-ab-testing' ),
	IL: _x( 'Israel', 'text', 'nelio-ab-testing' ),
	IT: _x( 'Italy', 'text', 'nelio-ab-testing' ),
	JM: _x( 'Jamaica', 'text', 'nelio-ab-testing' ),
	JP: _x( 'Japan', 'text', 'nelio-ab-testing' ),
	JE: _x( 'Jersey', 'text', 'nelio-ab-testing' ),
	JO: _x( 'Jordan', 'text', 'nelio-ab-testing' ),
	KZ: _x( 'Kazakhstan', 'text', 'nelio-ab-testing' ),
	KE: _x( 'Kenya', 'text', 'nelio-ab-testing' ),
	KI: _x( 'Kiribati', 'text', 'nelio-ab-testing' ),
	XK: _x( 'Kosovo', 'text', 'nelio-ab-testing' ),
	KP: _x( 'North Korea', 'text', 'nelio-ab-testing' ),
	KR: _x( 'South Korea', 'text', 'nelio-ab-testing' ),
	KW: _x( 'Kuwait', 'text', 'nelio-ab-testing' ),
	KG: _x( 'Kyrgyzstan', 'text', 'nelio-ab-testing' ),
	LA: _x( 'Lao People’s Democratic Republic', 'text', 'nelio-ab-testing' ),
	LV: _x( 'Latvia', 'text', 'nelio-ab-testing' ),
	LB: _x( 'Lebanon', 'text', 'nelio-ab-testing' ),
	LS: _x( 'Lesotho', 'text', 'nelio-ab-testing' ),
	LR: _x( 'Liberia', 'text', 'nelio-ab-testing' ),
	LY: _x( 'Libya', 'text', 'nelio-ab-testing' ),
	LI: _x( 'Liechtenstein', 'text', 'nelio-ab-testing' ),
	LT: _x( 'Lithuania', 'text', 'nelio-ab-testing' ),
	LU: _x( 'Luxembourg', 'text', 'nelio-ab-testing' ),
	MO: _x( 'Macao', 'text', 'nelio-ab-testing' ),
	MG: _x( 'Madagascar', 'text', 'nelio-ab-testing' ),
	MW: _x( 'Malawi', 'text', 'nelio-ab-testing' ),
	MY: _x( 'Malaysia', 'text', 'nelio-ab-testing' ),
	MV: _x( 'Maldives', 'text', 'nelio-ab-testing' ),
	ML: _x( 'Mali', 'text', 'nelio-ab-testing' ),
	MT: _x( 'Malta', 'text', 'nelio-ab-testing' ),
	MH: _x( 'Marshall Islands', 'text', 'nelio-ab-testing' ),
	MQ: _x( 'Martinique', 'text', 'nelio-ab-testing' ),
	MR: _x( 'Mauritania', 'text', 'nelio-ab-testing' ),
	MU: _x( 'Mauritius', 'text', 'nelio-ab-testing' ),
	YT: _x( 'Mayotte', 'text', 'nelio-ab-testing' ),
	MX: _x( 'Mexico', 'text', 'nelio-ab-testing' ),
	FM: _x( 'Micronesia, Federated States of', 'text', 'nelio-ab-testing' ),
	MD: _x( 'Moldova, Republic of', 'text', 'nelio-ab-testing' ),
	MC: _x( 'Monaco', 'text', 'nelio-ab-testing' ),
	MN: _x( 'Mongolia', 'text', 'nelio-ab-testing' ),
	ME: _x( 'Montenegro', 'text', 'nelio-ab-testing' ),
	MS: _x( 'Montserrat', 'text', 'nelio-ab-testing' ),
	MA: _x( 'Morocco', 'text', 'nelio-ab-testing' ),
	MZ: _x( 'Mozambique', 'text', 'nelio-ab-testing' ),
	MM: _x( 'Myanmar', 'text', 'nelio-ab-testing' ),
	NA: _x( 'Namibia', 'text', 'nelio-ab-testing' ),
	NR: _x( 'Nauru', 'text', 'nelio-ab-testing' ),
	NP: _x( 'Nepal', 'text', 'nelio-ab-testing' ),
	NL: _x( 'Netherlands', 'text', 'nelio-ab-testing' ),
	NC: _x( 'New Caledonia', 'text', 'nelio-ab-testing' ),
	NZ: _x( 'New Zealand', 'text', 'nelio-ab-testing' ),
	NI: _x( 'Nicaragua', 'text', 'nelio-ab-testing' ),
	NE: _x( 'Niger', 'text', 'nelio-ab-testing' ),
	NG: _x( 'Nigeria', 'text', 'nelio-ab-testing' ),
	NU: _x( 'Niue', 'text', 'nelio-ab-testing' ),
	NF: _x( 'Norfolk Island', 'text', 'nelio-ab-testing' ),
	MK: _x( 'North Macedonia, Republic of', 'text', 'nelio-ab-testing' ),
	MP: _x( 'Northern Mariana Islands', 'text', 'nelio-ab-testing' ),
	NO: _x( 'Norway', 'text', 'nelio-ab-testing' ),
	OM: _x( 'Oman', 'text', 'nelio-ab-testing' ),
	PK: _x( 'Pakistan', 'text', 'nelio-ab-testing' ),
	PW: _x( 'Palau', 'text', 'nelio-ab-testing' ),
	PS: _x( 'Palestinian Territory, Occupied', 'text', 'nelio-ab-testing' ),
	PA: _x( 'Panama', 'text', 'nelio-ab-testing' ),
	PG: _x( 'Papua New Guinea', 'text', 'nelio-ab-testing' ),
	PY: _x( 'Paraguay', 'text', 'nelio-ab-testing' ),
	PE: _x( 'Peru', 'text', 'nelio-ab-testing' ),
	PH: _x( 'Philippines', 'text', 'nelio-ab-testing' ),
	PN: _x( 'Pitcairn', 'text', 'nelio-ab-testing' ),
	PL: _x( 'Poland', 'text', 'nelio-ab-testing' ),
	PT: _x( 'Portugal', 'text', 'nelio-ab-testing' ),
	PR: _x( 'Puerto Rico', 'text', 'nelio-ab-testing' ),
	QA: _x( 'Qatar', 'text', 'nelio-ab-testing' ),
	RE: _x( 'Reunion', 'text', 'nelio-ab-testing' ),
	RO: _x( 'Romania', 'text', 'nelio-ab-testing' ),
	RU: _x( 'Russian Federation', 'text', 'nelio-ab-testing' ),
	RW: _x( 'Rwanda', 'text', 'nelio-ab-testing' ),
	BL: _x( 'Saint Barthélemy', 'text', 'nelio-ab-testing' ),
	SH: _x( 'Saint Helena', 'text', 'nelio-ab-testing' ),
	KN: _x( 'Saint Kitts and Nevis', 'text', 'nelio-ab-testing' ),
	LC: _x( 'Saint Lucia', 'text', 'nelio-ab-testing' ),
	MF: _x( 'Saint Martin (French part)', 'text', 'nelio-ab-testing' ),
	PM: _x( 'Saint Pierre and Miquelon', 'text', 'nelio-ab-testing' ),
	VC: _x( 'Saint Vincent and the Grenadines', 'text', 'nelio-ab-testing' ),
	WS: _x( 'Samoa', 'text', 'nelio-ab-testing' ),
	SM: _x( 'San Marino', 'text', 'nelio-ab-testing' ),
	ST: _x( 'Sao Tome and Principe', 'text', 'nelio-ab-testing' ),
	SA: _x( 'Saudi Arabia', 'text', 'nelio-ab-testing' ),
	SN: _x( 'Senegal', 'text', 'nelio-ab-testing' ),
	RS: _x( 'Serbia', 'text', 'nelio-ab-testing' ),
	SC: _x( 'Seychelles', 'text', 'nelio-ab-testing' ),
	SL: _x( 'Sierra Leone', 'text', 'nelio-ab-testing' ),
	SG: _x( 'Singapore', 'text', 'nelio-ab-testing' ),
	SX: _x( 'Sint Maarten (Dutch part)', 'text', 'nelio-ab-testing' ),
	SK: _x( 'Slovakia', 'text', 'nelio-ab-testing' ),
	SI: _x( 'Slovenia', 'text', 'nelio-ab-testing' ),
	SB: _x( 'Solomon Islands', 'text', 'nelio-ab-testing' ),
	SO: _x( 'Somalia', 'text', 'nelio-ab-testing' ),
	ZA: _x( 'South Africa', 'text', 'nelio-ab-testing' ),
	GS: _x(
		'South Georgia and the South Sandwich Islands',
		'text',
		'nelio-ab-testing'
	),
	SS: _x( 'South Sudan', 'text', 'nelio-ab-testing' ),
	ES: _x( 'Spain', 'text', 'nelio-ab-testing' ),
	LK: _x( 'Sri Lanka', 'text', 'nelio-ab-testing' ),
	SD: _x( 'Sudan', 'text', 'nelio-ab-testing' ),
	SR: _x( 'Suriname', 'text', 'nelio-ab-testing' ),
	SJ: _x( 'Svalbard and Jan Mayen', 'text', 'nelio-ab-testing' ),
	SE: _x( 'Sweden', 'text', 'nelio-ab-testing' ),
	CH: _x( 'Switzerland', 'text', 'nelio-ab-testing' ),
	SY: _x( 'Syrian Arab Republic', 'text', 'nelio-ab-testing' ),
	TW: _x( 'Taiwan', 'text', 'nelio-ab-testing' ),
	TJ: _x( 'Tajikistan', 'text', 'nelio-ab-testing' ),
	TZ: _x( 'Tanzania, United Republic of', 'text', 'nelio-ab-testing' ),
	TH: _x( 'Thailand', 'text', 'nelio-ab-testing' ),
	TL: _x( 'Timor-Leste', 'text', 'nelio-ab-testing' ),
	TG: _x( 'Togo', 'text', 'nelio-ab-testing' ),
	TK: _x( 'Tokelau', 'text', 'nelio-ab-testing' ),
	TO: _x( 'Tonga', 'text', 'nelio-ab-testing' ),
	TT: _x( 'Trinidad and Tobago', 'text', 'nelio-ab-testing' ),
	TN: _x( 'Tunisia', 'text', 'nelio-ab-testing' ),
	TR: _x( 'Turkey', 'text', 'nelio-ab-testing' ),
	TM: _x( 'Turkmenistan', 'text', 'nelio-ab-testing' ),
	TC: _x( 'Turks and Caicos Islands', 'text', 'nelio-ab-testing' ),
	TV: _x( 'Tuvalu', 'text', 'nelio-ab-testing' ),
	UG: _x( 'Uganda', 'text', 'nelio-ab-testing' ),
	UA: _x( 'Ukraine', 'text', 'nelio-ab-testing' ),
	AE: _x( 'United Arab Emirates', 'text', 'nelio-ab-testing' ),
	GB: _x( 'United Kingdom', 'text', 'nelio-ab-testing' ),
	US: _x( 'United States of America', 'text', 'nelio-ab-testing' ),
	UM: _x(
		'United States Minor Outlying Islands',
		'text',
		'nelio-ab-testing'
	),
	UY: _x( 'Uruguay', 'text', 'nelio-ab-testing' ),
	UZ: _x( 'Uzbekistan', 'text', 'nelio-ab-testing' ),
	VU: _x( 'Vanuatu', 'text', 'nelio-ab-testing' ),
	VE: _x( 'Venezuela', 'text', 'nelio-ab-testing' ),
	VN: _x( 'Vietnam', 'text', 'nelio-ab-testing' ),
	VG: _x( 'Virgin Islands, British', 'text', 'nelio-ab-testing' ),
	VI: _x( 'Virgin Islands, U.S.', 'text', 'nelio-ab-testing' ),
	WF: _x( 'Wallis and Futuna', 'text', 'nelio-ab-testing' ),
	EH: _x( 'Western Sahara', 'text', 'nelio-ab-testing' ),
	YE: _x( 'Yemen', 'text', 'nelio-ab-testing' ),
	ZM: _x( 'Zambia', 'text', 'nelio-ab-testing' ),
	ZW: _x( 'Zimbabwe', 'text', 'nelio-ab-testing' ),
} );

export function getCountryName(
	countryCode: string,
	defaultName?: string
): string {
	const fallback = defaultName ?? _x( 'Unknown', 'text', 'nelio-ab-testing' );
	const aux: Record< string, string > = worldCountries;
	return aux[ countryCode ] ?? fallback;
}
